import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
// import { addProduct } from '../../Redux/ProductSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ProductCreate() {
  let navigate = useNavigate();
  
  const admin = sessionStorage.getItem('admin');

  useEffect(()=>{
    
    if(!admin)
      { 
        navigate('/login');
      }
  },[])
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [categories, setCategory] = useState([]);
  const [categoryValue, setCategoryValue] = useState([]);
  const [photo1, setPhoto1] = useState('');
  const [photo2, setPhoto2] = useState('');
  // const [photo, setPhoto] = useState([]);
  const [details, setDetails] = useState('');
  // const [description, setDescription] = useState('');


  // const products = useSelector((state) => state.products);
  // const dispatch = useDispatch(); 

  const handleImageUpload1 = (e) => {

    const file = e.target.files[0];
    setPhoto1(file);
  };
  const handleImageUpload2 = (e) => {

    const file = e.target.files[0];
    setPhoto2(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setPhoto([photo1, photo2]);
    // const photo = [photo1, photo2];
    const formData = new FormData();
    formData.append("name", name);   // Append the name field
    formData.append("price", price);   // Append the name field
    formData.append("details", details);   // Append the name field
    formData.append("category", categoryValue);   // Append the name field
    if (photo1) {
      formData.append("photo", photo1);
    }
    if (photo2) {
      formData.append("photo", photo2);
    }
    axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/createProduct", formData)
      .then((res) => {
        // console.log(res.data);
      })
      .catch((err) => console.log("ERROR in product create handlesubmit: ", err));
    // const newProduct = {
    //   id: products.length + 1,
    //   name,
    //   price,
    //   image,
    //   description,
    // };
    // dispatch(addProduct(newProduct));
    navigate('/productHome');
  };


  useEffect(() => {
    axios.get("https://sportsblendserver.netlify.app/.netlify/functions/api/displayCategory")
      .then((res) => {
        // console.log("\nTHe photos or data are ", res.data, "\n");
        setCategory(res.data);

      })
      .catch((err) => console.log(err));
  }, [])
  return (
    <div className='d-flex'>
      <Sidebar />
      <div className="custom-form-container w-100 vh-100 justify-content-center align-items-center">
        <div className="custom-form w-50 border bg-dark text-white p-5">
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor='name'>Name</label>
              <input
                type='text'
                name='name'
                placeholder="Enter Product Name"
                className='custom-input form-control'
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor='price'>Price</label>
              <input
                type='text'
                name='price'
                placeholder="Enter Product Price"
                className='custom-input form-control'
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor='category'>Category</label>
              <select className='custom-input form-control' value={categoryValue} onChange={(e) => setCategoryValue(e.target.value)}>
                <option value="/" selected>Select Category</option>
                {categories.map(({ name, _id }) => (
                  <option value={_id}>{name}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor='photo2'>Front Photo</label>
              <input
                type='file'
                accept='image/*'
                name='photo1'
                className='custom-input form-control'
                onChange={handleImageUpload1}
                required
              />
            </div>
            <div>
              <label htmlFor='photo2'>Back Photo</label>
              <input
                type='file'
                accept='image/*'
                name='photo2'
                className='custom-input form-control'
                onChange={handleImageUpload2}

              />
            </div>

            <div>
              <label htmlFor='details'>Details</label>
              <textarea
                type='text'
                name='details'
                placeholder="Enter Product Description"
                className='custom-input form-control'
                onChange={(e) => setDetails(e.target.value)}
                required
              />
              <br />
              <button className='custom-button btn btn-primary'>Create</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProductCreate;
